export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const GET_ACCESS_TOKEN_SUCCESS = "GET_ACCESS_TOKEN_SUCCESS";
export const GET_ACCESS_TOKEN_FAILURE = "GET_ACCESS_TOKEN_FAILURE";

export const SAVE_REFRESH_TOKEN_PROMISE = "SAVE_REFRESH_TOKEN_PROMISE";
export const CLEAR_REFRESH_TOKEN_PROMISE = "CLEAR_REFRESH_TOKEN_PROMISE";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
